// extracted by mini-css-extract-plugin
export default {"container":"CommentsList-module__container--PcGlG"};